import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createZoneFailed, createZoneSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* createZone(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/zone`;
    const dataResponse = yield makeRequest(url, action.payload, action, 'POST', true);
    if (dataResponse.status === OK) {
      yield put(createZoneSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(createZoneFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(createZoneFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
